import React, { ChangeEventHandler } from "react";
import { Form } from "react-bootstrap";

interface Props {
	controlId: string;
	label?: string;
	options: any;
	onChange: ChangeEventHandler<HTMLInputElement>;
	selectedOption: any;
	isInvalid?: boolean;
	disabled?: boolean;
}

const BftRadioGroup: React.FC<Props> = (props) => {
	const { controlId, label, options, onChange, selectedOption, isInvalid, disabled } = props;

	return (
		<Form.Group className="container" controlId={controlId}>
			{label && (
				<Form.Label>
					<h6 className="my-3">{label}</h6>
				</Form.Label>
			)}

			{options.map((option: any) => (
				<Form.Check
					className={`bft-radio ${selectedOption === option.value ? "checked" : ""}`}
					key={option.id}
					type="radio"
					name={controlId}
					label={option.label}
					value={option.value}
					checked={selectedOption === option.value}
					onChange={onChange}
					isInvalid={isInvalid}
					disabled={disabled}
				/>
			))}
		</Form.Group>
	);
};

export default BftRadioGroup;
